// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations'

function MarketHVAC() {

     useGaspAnimations()
     
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">HVAC</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                            <Filter/>    
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated bdFadeUp">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}
                                                   <img src="assets/images/Market-Images/03.webp" alt="Awesome Image"/>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>HVAC Industry</span></h1>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>Custom-Engineered HVAC Solutions for Industrial and Commercial Applications</span>
                                                    <p className="top">
                                                       Indus Refrigeration is a trusted name in the HVAC (Heating, Ventilation, and Air Conditioning) industry, offering comprehensive climate control solutions for industrial, commercial, and institutional facilities. With a strong legacy in thermal engineering and system integration, Indus designs and delivers high-performance HVAC systems that ensure energy efficiency, indoor air quality, and thermal comfort across diverse environments.
                                                    </p>
                                                    <p>
                                                       Whether it's a pharmaceutical cleanroom, food processing facility, IT server room, commercial complex, or industrial plant, Indus HVAC systems are engineered to meet exacting standards for temperature, humidity, airflow, and pressure control. Our solutions are tailored for both comfort cooling and process-driven climate control needs.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings in HVAC:</h2>
                                                </div>
                                               <p>Air Handling Units (AHUs), Fan Coil Units (FCUs), and air washers</p>

                                                <p>Central chilled water plants with water-cooled or air-cooled chillers</p>

                                                <p>Ductable and packaged air conditioning systems</p>

                                                <p>Precision HVAC systems for cleanrooms, laboratories, and data centers</p>

                                                <p>Dehumidification and humidity control systems</p>

                                                <p>Turnkey HVAC projects: design, supply, installation, commissioning, and AMC</p>

                                                <p>Combining advanced technology with practical engineering, Indus Refrigeration ensures optimal HVAC system performance with low operational costs, long-term reliability, and minimal environmental impact. Our HVAC solutions support critical applications where climate control isn’t optional—it's essential.</p>
                                               </div>    
                                        </div>
                                    </div>
                              
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketHVAC;


